// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Grace_GrantInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Grace_GrantInput — body for POST /subscriptions/grace/grant.
 *
 * Required: franquia_id (positive int), days (positive int >= 1),
 * plan_id (positive int — the plan the grace period is being granted for).
 * Optional: reason (string).
 *
 * plan_id is required on the wire, but the controller fills it in from the
 * franchise's live subscription (when one exists) BEFORE validation runs —
 * see Grace::grant() — so a staff caller extending an existing subscriber
 * does not have to repeat the plan_id it already knows.
 */
import { registerContract } from './validate'

export interface Grace_GrantInput {
franquia_id: number
days: number
plan_id: number
reason?: string
}

registerContract('Grace_GrantInput', {
  franquia_id: { type: 'number',  required: true },
  days:        { type: 'number',  required: true },
  plan_id:     { type: 'number',  required: true },
  reason:      { type: 'string',  required: false },
})
